<template>
    <v-col :cols="cols" :md="md">
      
      <emc-form-auto-complete 
        v-model="model"
        :items="items"
        :label="label"
        :outlined="outlined"
        :disabled="disabled"
        :error-messages="errorMessages"
        :error="error"
        :loading="loading"
        @onClick="getData"
        :hide-no-data="hideNoData"
        :clearable="clearable"
      >
        <template v-slot:item="{item}">
            <v-list-item-icon>
                  <v-icon :color="item.color">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-html="item.name"></v-list-item-title>
            </v-list-item-content>
        </template>

      </emc-form-auto-complete>
    </v-col>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    name: 'SelectType',
    props: {
        cols: { type: [String, Number], default: 12 },
        md: { type: [String, Number], default: 6 },
        value: { type: [String, Number, Object] },
        errorMessages: { type: Array, required: false },
        error: { type: Boolean, required: false },
        disabled: { type: Boolean, required: false },
        outlined: { type: Boolean, required: false },
        item: { type: Object, required: false },
        hideNoData: { type: Boolean, required: false },
        label: { type: String, default: 'Tipo' },
        clearable: { type: Boolean, required: false },
        filterActive: { type: Boolean, default: false },
    },
    data () {
      return {
        loading: false,
        collection: []
      }
    },
    computed: {
      model: {
          get() {
              return this.value
          },
          set(val) {
              this.$emit('input', val)
          }
      },
      items: {
        get() {
            if(this.collection.length > 0) {
              return this.collection
            } else {
              return [this.item]
            }
        },
        set(val) {
           this.collection = val
        }
      }

    },
    methods: {
      ...mapActions('ticket', ['ActionTicketTypesIndex']),
      getData() {

        if(this.items.length > 2)
          return;
        
        this.loading = true;
        
        let payload = {};
          
        if(this.filterActive){
          payload.find_columns = {
            active: 1
          };
        }

        this.ActionTicketTypesIndex(payload)
                .then((r) => {
                    this.items = r.data
                })
                .finally(() => {
                    this.loading = false
                })
      }
    }
  }
</script>